import { Container } from '@material-ui/core';
import React from 'react';
import { PriceForm } from './../../../components/PriceForm';
export const PriceAndImageComponent = (props: any) => (
  <Container maxWidth='md'>
    <PriceForm {...props} />
  </Container>
);
